export const settings = {
  version: '1.3.0',
};

export default settings;
